import { ChangeDetectionStrategy, Component, computed, inject, model } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { HmiLookupService } from '../../../../services/hmi-lookup.service';

@Component({
  selector: 'uretim-sayac-edit',
  standalone: true,
  imports: [DecimalPipe, FormsModule, NzInputModule, NzInputNumberModule, NzSelectModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="us-edit">
      <div class="us-baslik">
        <div class="us-baslik-ikon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/>
          </svg>
        </div>
        <span>Üretim Sayacı</span>
      </div>

      <div class="us-form">
        <div class="form-grup">
          <label>Tezgah <span class="zorunlu">*</span></label>
          <div class="input-wrap">
            <nz-select
              [ngModel]="p()?.tezgah"
              (ngModelChange)="guncelle('tezgah', $event)"
              nzPlaceHolder="Makine seçin..."
              nzAllowClear nzShowSearch nzServerSearch
              (nzOnSearch)="lookup.makineleriYukle($event)"
              (nzOpenChange)="$event && lookup.makineleriYukle()"
              style="width:100%"
              [nzCustomTemplate]="usTezgahTpl">
              @for (m of lookup.makineler(); track m._id) {
                <nz-option [nzValue]="m.makineAdi" [nzLabel]="m.makineAdi" nzCustomContent>
                  <div class="sel-item"><span class="sel-emoji">⚙️</span><div class="sel-bilgi"><span class="sel-ad">{{ m.makineAdi }}</span><span class="sel-detay">{{ m.makineKodu || '' }}{{ m.tip ? ' · ' + m.tip : '' }}</span></div></div>
                </nz-option>
              }
            </nz-select>
            <ng-template #usTezgahTpl let-selected>
              <span class="sel-item"><span class="sel-emoji">⚙️</span><span class="sel-ad">{{ selected.nzLabel }}</span></span>
            </ng-template>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Ürün</label>
          <div class="input-wrap">
            <input nz-input autocomplete="off" readonly onfocus="this.removeAttribute('readonly')"
              [ngModel]="p()?.urun || ''"
              (ngModelChange)="guncelle('urun', $event)"
              placeholder="Ürün adı"/>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="us-ayirici"></div>

        <div class="form-grup">
          <label>Hedef</label>
          <div class="input-wrap">
            <nz-input-number
              [ngModel]="p()?.hedef || null"
              (ngModelChange)="guncelleHedef($event)"
              [nzMin]="1" [nzStep]="1"
              nzPlaceHolder="Hedef adet"
              style="width:100%">
            </nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Gerçekleşen</label>
          <div class="input-wrap">
            <nz-input-number
              [ngModel]="p()?.gerceklesen || null"
              (ngModelChange)="guncelleGerceklesen($event)"
              [nzMin]="0" [nzStep]="1"
              nzPlaceHolder="Gerçekleşen adet"
              style="width:100%">
            </nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="form-grup">
          <label>Fire</label>
          <div class="input-wrap">
            <nz-input-number
              [ngModel]="p()?.fire || null"
              (ngModelChange)="guncelle('fire', $event)"
              [nzMin]="0" [nzStep]="1"
              nzPlaceHolder="Fire adet"
              style="width:100%">
            </nz-input-number>
            <div class="input-glow"></div>
          </div>
        </div>

        <div class="us-ayirici"></div>

        <div class="form-grup">
          <label>Verimlilik %</label>
          <div class="verimlilik-gosterge">
            <div class="verimlilik-bar">
              <div class="verimlilik-dolgu" [style.width.%]="verimlilik()"></div>
            </div>
            <span class="verimlilik-deger">{{ verimlilik() | number:'1.1-1' }}%</span>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`

    :host { display: block; }

    .us-edit { display: flex; flex-direction: column; gap: 0; padding: 0; }

    .us-baslik {
      display: flex; align-items: center; gap: 10px;
      padding: 12px 16px; margin-bottom: 4px; border-radius: 10px;
      background: linear-gradient(135deg, var(--py-arkaplan-soluk, rgba(0,0,0,0.03)), transparent);
    }

    .us-baslik-ikon {
      width: 32px; height: 32px; border-radius: 8px;
      display: flex; align-items: center; justify-content: center;
      background: linear-gradient(135deg, #7c3aed, #a855f7);
      color: #fff; flex-shrink: 0;
      box-shadow: 0 2px 8px rgba(124, 58, 237, 0.35);
      position: relative;
    }

    .us-baslik-ikon::after {
      content: ''; position: absolute; inset: 0; border-radius: inherit;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.2) 50%, transparent 100%);
      background-size: 200% 100%; animation: shimmer 3s infinite linear; pointer-events: none;
    }

    .us-baslik span { font-size: 13px; font-weight: 600; color: var(--py-metin, #333); letter-spacing: 0.3px; }

    .us-form { display: flex; flex-direction: column; gap: 14px; padding: 4px 2px; }

    .us-ayirici {
      height: 1px; opacity: 0.4; margin: 2px 0;
      background: linear-gradient(90deg, transparent, var(--py-kenarlik, #d9d9d9) 20%, var(--py-kenarlik, #d9d9d9) 80%, transparent);
    }

    .form-grup { display: flex; flex-direction: column; gap: 5px; }

    .form-grup label {
      font-size: 11px; font-weight: 500; text-transform: uppercase; letter-spacing: 0.6px; padding-left: 2px;
      color: var(--py-metin-ucuncul, rgba(0,0,0,0.45)); transition: color 0.2s ease;
    }

    .form-grup:focus-within label { color: var(--py-link, #1890ff); }

    .zorunlu { color: #ff4d4f; font-size: 13px; line-height: 1; vertical-align: middle; }

    .input-wrap { position: relative; }

    .input-glow {
      position: absolute; bottom: 0; left: 50%; width: 0; height: 2px; border-radius: 1px;
      background: linear-gradient(90deg, #7c3aed, #1890ff, #7c3aed);
      transition: width 0.35s cubic-bezier(0.4, 0, 0.2, 1), left 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease;
      opacity: 0; pointer-events: none; z-index: 1;
    }

    .input-wrap:focus-within .input-glow { width: 100%; left: 0; opacity: 1; }

    .input-wrap input[nz-input] {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9); border-radius: 8px;
      padding: 7px 11px; font-size: 13px; color: var(--py-metin, #333);
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap input[nz-input]:hover { border-color: var(--py-kenarlik-hover, #b3b3b3); background: var(--py-arkaplan-hover, #f5f5f5); }
    .input-wrap input[nz-input]:focus { border-color: var(--py-kenarlik-aktif, #1890ff); background: var(--py-input-arka, #fff); box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1); outline: none; }

    .input-wrap ::ng-deep .ant-input-number {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important; border-radius: 8px !important;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }

    .input-wrap:hover ::ng-deep .ant-input-number { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; }
    .input-wrap:focus-within ::ng-deep .ant-input-number { border-color: var(--py-kenarlik-aktif, #1890ff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    .input-wrap ::ng-deep .ant-select-selector {
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02)) !important;
      border: 1px solid var(--py-kenarlik, #d9d9d9) !important;
      border-radius: 8px !important; min-height: 34px;
      transition: border-color 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
    }
    .input-wrap:hover ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-hover, #b3b3b3) !important; background: var(--py-arkaplan-hover, #f5f5f5) !important; }
    .input-wrap:focus-within ::ng-deep .ant-select-selector { border-color: var(--py-kenarlik-aktif, #1890ff) !important; background: var(--py-input-arka, #fff) !important; box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.1) !important; }

    .verimlilik-gosterge {
      display: flex; align-items: center; gap: 12px;
      padding: 10px 14px; border-radius: 10px;
      background: var(--py-arkaplan-soluk, rgba(0,0,0,0.02));
      border: 1px solid var(--py-kenarlik, #d9d9d9);
    }

    .verimlilik-bar { flex: 1; height: 8px; border-radius: 4px; background: rgba(0,0,0,0.06); overflow: hidden; }

    .verimlilik-dolgu {
      height: 100%; border-radius: 4px;
      background: linear-gradient(90deg, #7c3aed, #a855f7);
      transition: width 0.5s cubic-bezier(0.22, 1, 0.36, 1);
    }

    .verimlilik-deger { font-size: 14px; font-weight: 700; color: #7c3aed; min-width: 52px; text-align: right; }

    @keyframes shimmer { 0% { background-position: -200% center; } 100% { background-position: 200% center; } }
  `],
})
export class UretimSayacEditComponent extends FikoYTKokBilesenComponent {
  parametreler = model<any>();
  lookup = inject(HmiLookupService);

  constructor() { super(); this.lookup.makineleriYukle(); }

  p = computed(() => this.parametreler()?.ek || {});

  verimlilik = computed(() => {
    const ek = this.p();
    if (!ek?.hedef || ek.hedef <= 0) return 0;
    return Math.min(((ek.gerceklesen || 0) / ek.hedef) * 100, 100);
  });

  guncelle(alan: string, deger: any) {
    const params = this.parametreler();
    if (params?.ek) {
      params.ek[alan] = deger;
      this.parametreler.set({ ...params });
    }
  }

  guncelleHedef(deger: number) {
    this.guncelle('hedef', deger);
  }

  guncelleGerceklesen(deger: number) {
    this.guncelle('gerceklesen', deger);
  }
}
